import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import '@/shared/i18n/i18n'

const rootElement = document.getElementById('root')
if (!rootElement) {
    throw new Error('Root element not found. Check that index.html has <div id="root">.')
}

ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
)
